var React = require('react');

function StripBlueHorizontalSmallInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m223.46 0 17.44 17.27v-17.27zm-15.08 19.47-19.66-19.47h-26.07l19.66 19.47zm-60.81 0-19.65-19.47h-26.08l19.66 19.47zm-60.81 0-19.65-19.47h-26.08l19.66 19.47zm-60.81 0-19.66-19.47h-6.29v19.47z","fill":"#001d8a"}));
}

StripBlueHorizontalSmallInline.defaultProps = {"viewBox":"0 0 240.9 19.47"};

module.exports = StripBlueHorizontalSmallInline;

StripBlueHorizontalSmallInline.default = StripBlueHorizontalSmallInline;
